import React, { useEffect, useState, useRef } from 'react'
import ChronometerStyle from "./Chronometer.module.scss"
import StopWatch from "../Icons/StopWatch"

interface ChronometerProps {
  isPlay: boolean
  showCentiseconds?: boolean
}

export const Chronometer = ({
  isPlay,
  showCentiseconds = true
}: ChronometerProps): React.JSX.Element => {
  const [time, setTime] = useState(0)
  const intervalRef = useRef<number | null>(null)
  const startTimeRef = useRef<number | null>(null)

  useEffect(() => {
    if (isPlay) {
      startTimeRef.current = performance.now()
      intervalRef.current = window.setInterval(() => {
        if (startTimeRef.current) {
          setTime(performance.now() - startTimeRef.current)
        }
      }, 10)
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [isPlay])

  const totalSeconds = time / 1000
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.floor(totalSeconds % 60)
  const centiseconds = Math.floor((totalSeconds - Math.floor(totalSeconds)) * 100)

  const formattedCentiseconds = showCentiseconds
    ? centiseconds.toString().padStart(2, "0")
    : Math.floor(centiseconds / 10).toString()

  const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}:${formattedCentiseconds}`

  return (
    <div className={ChronometerStyle.chrono}>
      <StopWatch width={25} height={25}/> {formattedTime}
    </div>
  )
}
